<app-widget [name]="'stats'" [header]="'Statistics'" [isWorking]="isLoading" [refreshFunc]="refresh" [refreshRatesInMinutes]="[30,60]">

  <div class="tw-flex tw-flex-col tw-items-start tw-justify-normal tw-gap-3">
    @for (report of regionUsageReports; track report.region) {
      <div  class="tw-flex tw-flex-col tw-items-start tw-justify-normal tw-gap-1">
        <h3>{{report.region}}</h3>
        <p>Accounts: {{report.activeAccounts}} active, {{report.inactiveAccounts}} inactive</p>
        <p>Environments: {{report.activeEnvironments}} active, {{report.inactiveEnvironments}} inactive</p>
      </div>
    }
  </div>

</app-widget>